import {
  FormTemplateQuestionFieldOptionConditionEnum,
  FormTemplateQuestionFieldsKindEnum,
} from 'graphql-common';

export const defaultQuestionParams = {
  attachmentsAttached: [],
  description: '',
  name: '',
  required: false,
  showAttachments: false,
  showDescription: false,
};

export const defaultFieldParams = {
  required: false,
  options: [],
};

export const kindFieldsWithValidityHint = [
  FormTemplateQuestionFieldsKindEnum.Checkbox,
  FormTemplateQuestionFieldsKindEnum.RadioButton,
  FormTemplateQuestionFieldsKindEnum.SingleSelect,
  FormTemplateQuestionFieldsKindEnum.MinMax,
  FormTemplateQuestionFieldsKindEnum.YesNo,
  FormTemplateQuestionFieldsKindEnum.NumberInput,
];

export const kindFieldsWithoutPreviewInEditMode = [
  FormTemplateQuestionFieldsKindEnum.SingleSelect,
  FormTemplateQuestionFieldsKindEnum.RadioButton,
  FormTemplateQuestionFieldsKindEnum.Checkbox,
  FormTemplateQuestionFieldsKindEnum.YesNo,
  FormTemplateQuestionFieldsKindEnum.CheckboxButtonGrid,
  FormTemplateQuestionFieldsKindEnum.DecisionBox,
  FormTemplateQuestionFieldsKindEnum.ImportantNotice,
  FormTemplateQuestionFieldsKindEnum.ImportantNotice,
  FormTemplateQuestionFieldsKindEnum.Section,
  FormTemplateQuestionFieldsKindEnum.Checklist,
];

export const kindFieldsWithAddOption = [
  FormTemplateQuestionFieldsKindEnum.Checkbox,
  FormTemplateQuestionFieldsKindEnum.MinMax,
  FormTemplateQuestionFieldsKindEnum.NumberInput,
  FormTemplateQuestionFieldsKindEnum.RadioButton,
  FormTemplateQuestionFieldsKindEnum.CheckboxButtonGrid,
  FormTemplateQuestionFieldsKindEnum.SingleSelect,
  FormTemplateQuestionFieldsKindEnum.Checklist,
];

export const kindFieldsWithPreviewForEditMode = [
  FormTemplateQuestionFieldsKindEnum.MinMax,
  FormTemplateQuestionFieldsKindEnum.NumberInput,
];

export const kindFieldsWithNumericInputType = [
  FormTemplateQuestionFieldsKindEnum.MinMax,
  FormTemplateQuestionFieldsKindEnum.NumberInput,
];

export const kindFieldsWithCondition = [
  FormTemplateQuestionFieldsKindEnum.MinMax,
  FormTemplateQuestionFieldsKindEnum.NumberInput,
];

export const kindFieldsWithCheckboxPreview = [
  FormTemplateQuestionFieldsKindEnum.Checkbox,
  FormTemplateQuestionFieldsKindEnum.DecisionBox,
];

export const kindFieldsWithRadioButtonPreview = [
  FormTemplateQuestionFieldsKindEnum.RadioButton,
];

export const kindFieldsWithoutDeleteOption = [
  FormTemplateQuestionFieldsKindEnum.YesNo,
];

export const kindFieldsWithDeleteOption = [
  FormTemplateQuestionFieldsKindEnum.MinMax,
  FormTemplateQuestionFieldsKindEnum.NumberInput,
];

export const kindFieldsWithoutRequiredField = [
  FormTemplateQuestionFieldsKindEnum.Section,
  FormTemplateQuestionFieldsKindEnum.ImportantNotice,
];

export const kindFieldsWithAllowDisplayLastAnswer = [
  FormTemplateQuestionFieldsKindEnum.NumberInput,
  FormTemplateQuestionFieldsKindEnum.MinMax,
];

export const kindFieldsWithResponseLimitByGroup = [
  FormTemplateQuestionFieldsKindEnum.CheckboxButtonGrid,
];

export const kindFieldsWithResponseLimitToOne = [
  FormTemplateQuestionFieldsKindEnum.Checklist,
];

export const fieldLabelByCondition = {
  [FormTemplateQuestionFieldOptionConditionEnum.Between]: 'eg-label',
  [FormTemplateQuestionFieldOptionConditionEnum.Equal]: 'eg-label',
  [FormTemplateQuestionFieldOptionConditionEnum.GreaterThan]:
    'if-more-than-label',
  [FormTemplateQuestionFieldOptionConditionEnum.LessThan]: 'if-less-than-label',
  [FormTemplateQuestionFieldOptionConditionEnum.NotEqual]: 'eg-label',
};

export const conditionNavItemLabelByCondition = {
  [FormTemplateQuestionFieldOptionConditionEnum.Between]: 'condition-between',
  [FormTemplateQuestionFieldOptionConditionEnum.Equal]: 'condition-equal',
  [FormTemplateQuestionFieldOptionConditionEnum.GreaterThan]:
    'condition-greater-than',
  [FormTemplateQuestionFieldOptionConditionEnum.LessThan]:
    'condition-less-than',
  [FormTemplateQuestionFieldOptionConditionEnum.NotEqual]:
    'condition-not-equal',
};

export const conditionIcons = {
  [FormTemplateQuestionFieldOptionConditionEnum.Between]: '(...)',
  [FormTemplateQuestionFieldOptionConditionEnum.Equal]: '=',
  [FormTemplateQuestionFieldOptionConditionEnum.GreaterThan]: '>',
  [FormTemplateQuestionFieldOptionConditionEnum.LessThan]: '<',
  [FormTemplateQuestionFieldOptionConditionEnum.NotEqual]: '≠',
};

export const conditionNavigateTitleSuffix = {
  [FormTemplateQuestionFieldOptionConditionEnum.Between]: '(...)',
  [FormTemplateQuestionFieldOptionConditionEnum.Equal]: '=',
  [FormTemplateQuestionFieldOptionConditionEnum.GreaterThan]: '>',
  [FormTemplateQuestionFieldOptionConditionEnum.LessThan]: '<',
  [FormTemplateQuestionFieldOptionConditionEnum.NotEqual]: '≠',
};
